import React, { useContext, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { Stack, PrimaryButton, DefaultButton } from '@fluentui/react';
import {
  useWizardService,
  matchStepState,
  STEP_STATES,
  WIZARD_EVENTS,
} from '@bingads-webui-react/wizard';
import { CancelButton } from '@bingads-webui-react/wizard-ui-library';
import { ActivityContext } from '@bingads-webui-react/hoc-with-signal';

const Save = () => {
  const i18n = useContext(I18nContext);

  const activity = useContext(ActivityContext);

  const { state, send } = useWizardService();
  const isBlocking = matchStepState(state, STEP_STATES.FETCHING) || matchStepState(state, STEP_STATES.LOADING) || matchStepState(state, STEP_STATES.SAVING);

  const onNextClicked = useCallback(() => {
    if (activity) {
      activity.signal('onSaveAndPublishClicked');
    }
    send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { isCreateAnother: false });
    send(WIZARD_EVENTS.SAVE_AND_EXIT);
  }, [activity, send]);

  const buttonText = useMemo(() => i18n.getString(_TL_('Save ad')), [i18n]);

  return (
    <PrimaryButton
      disabled={isBlocking}
      onClick={onNextClicked}
      className="step-save-and-publish-button"
    >
      {buttonText}
    </PrimaryButton>
  );
};

export const SaveAndCreateAnother = () => {
  const i18n = useContext(I18nContext);

  const { state, send } = useWizardService();
  const isBlocking = matchStepState(state, STEP_STATES.FETCHING) || matchStepState(state, STEP_STATES.LOADING) || matchStepState(state, STEP_STATES.SAVING);

  const onNextClicked = useCallback(() => {
    send(WIZARD_EVENTS.UPDATE_WIZARD_DATA, { isCreateAnother: true });
    send(WIZARD_EVENTS.SAVE_AND_NEXT);
  }, [send]);

  return (
    <DefaultButton
      disabled={isBlocking}
      onClick={onNextClicked}
      className="step-next-button"
    >
      {i18n.getString(_TL_('Save & create another ad'))}
    </DefaultButton>
  );
};


export const EditAdFooter = ({
  cancelButtonText,
}) => (
  <Stack horizontal tokens={{ childrenGap: 16 }}>
    <Save />
    <SaveAndCreateAnother />
    <CancelButton buttonText={cancelButtonText} />
  </Stack>
);
EditAdFooter.propTypes = {
  cancelButtonText: PropTypes.string,
};
EditAdFooter.defaultProps = {
  cancelButtonText: undefined,
};
